import React from "react";

export default function About() {
    return (
        <section id="about" className="about">

            <div className="about-content">
                <h2>About V/D Ceilings</h2>

                <p>
                    About V/D Ceilings
                    Founded in 2020, V/D Ceilings was created with a clear purpose: to deliver modern, efficient, and high-quality dry construction solutions, combining technical accuracy with a finish that enhances every space. Since the beginning, we have focused on building a reputation based on trust, professionalism, and consistent results—from small renovations to more complex projects.

                    We are specialists in Steel Frame, Drywall, ceilings, partitions, and complete interior systems, providing solutions designed to improve comfort, optimize layouts, and add value to residential and commercial environments. Every project is approached with attention to detail, using proper methods and materials to ensure straight lines, precise leveling, clean installations, and long-lasting performance.

                    Our team is made up of qualified professionals who follow best practices in execution, prioritizing safety, organization, and efficiency on site. We respect deadlines, keep communication clear throughout the process, and work with a strong commitment to quality at every stage—planning, measuring, installation, and finishing.

                    At V/D Ceilings, we believe that a great result is not only about appearance, but also about how well everything functions over time. That’s why we aim to deliver projects with technical precision and impeccable finishing, tailored to each client’s needs and the specific demands of the space.
                </p>

            </div>

        </section>
    );
}